// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/graph_conflicts.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.projectdata.v1.SourceObservationView
 */ export class SourceObservationView extends Message {
    static fromBinary(bytes, options) {
        return new SourceObservationView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SourceObservationView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SourceObservationView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SourceObservationView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string node_id = 2;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: string field = 3;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string value = 4;
   */ _define_property(this, "value", ""), /**
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_record_id = 6;
   */ _define_property(this, "sourceRecordId", ""), /**
   * @generated from field: string source_record_version = 7;
   */ _define_property(this, "sourceRecordVersion", ""), /**
   * prime | sub | ""
   *
   * @generated from field: string scope = 8;
   */ _define_property(this, "scope", ""), /**
   * obligation | ceiling | options | workshare | current_end | ultimate_end | ""
   *
   * @generated from field: string measure = 9;
   */ _define_property(this, "measure", ""), /**
   * @generated from field: string period_start = 10;
   */ _define_property(this, "periodStart", ""), /**
   * @generated from field: string period_end = 11;
   */ _define_property(this, "periodEnd", ""), /**
   * @generated from field: google.protobuf.Timestamp observed_at = 12;
   */ _define_property(this, "observedAt", void 0), /**
   * @generated from field: double confidence = 13;
   */ _define_property(this, "confidence", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SourceObservationView, "runtime", proto3);
_define_property(SourceObservationView, "typeName", "mono.projectdata.v1.SourceObservationView");
_define_property(SourceObservationView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_record_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "measure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "period_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "observed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetEnrichmentStateRequest
 */ export class GetEnrichmentStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetEnrichmentStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEnrichmentStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEnrichmentStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEnrichmentStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string node_id = 1;
   */ _define_property(this, "nodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEnrichmentStateRequest, "runtime", proto3);
_define_property(GetEnrichmentStateRequest, "typeName", "mono.projectdata.v1.GetEnrichmentStateRequest");
_define_property(GetEnrichmentStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnrichmentApplicationView
 */ export class EnrichmentApplicationView extends Message {
    static fromBinary(bytes, options) {
        return new EnrichmentApplicationView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnrichmentApplicationView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnrichmentApplicationView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnrichmentApplicationView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string observation_id = 2;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string field = 4;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string applied_value = 5;
   */ _define_property(this, "appliedValue", ""), /**
   * @generated from field: string source = 6;
   */ _define_property(this, "source", ""), /**
   * @generated from field: double confidence = 7;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: google.protobuf.Timestamp applied_at = 8;
   */ _define_property(this, "appliedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp reversed_at = 9;
   */ _define_property(this, "reversedAt", void 0), /**
   * @generated from field: string reversed_by = 10;
   */ _define_property(this, "reversedBy", ""), /**
   * @generated from field: string reversal_rationale = 11;
   */ _define_property(this, "reversalRationale", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnrichmentApplicationView, "runtime", proto3);
_define_property(EnrichmentApplicationView, "typeName", "mono.projectdata.v1.EnrichmentApplicationView");
_define_property(EnrichmentApplicationView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "applied_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "applied_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "reversed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "reversed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "reversal_rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetEnrichmentStateResponse
 */ export class GetEnrichmentStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetEnrichmentStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEnrichmentStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEnrichmentStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEnrichmentStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool enabled = 1;
   */ _define_property(this, "enabled", false), /**
   * @generated from field: repeated mono.projectdata.v1.EnrichmentApplicationView applications = 2;
   */ _define_property(this, "applications", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEnrichmentStateResponse, "runtime", proto3);
_define_property(GetEnrichmentStateResponse, "typeName", "mono.projectdata.v1.GetEnrichmentStateResponse");
_define_property(GetEnrichmentStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "applications",
            kind: "message",
            T: EnrichmentApplicationView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetEnrichmentEnabledRequest
 */ export class SetEnrichmentEnabledRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetEnrichmentEnabledRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetEnrichmentEnabledRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetEnrichmentEnabledRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetEnrichmentEnabledRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool enabled = 1;
   */ _define_property(this, "enabled", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetEnrichmentEnabledRequest, "runtime", proto3);
_define_property(SetEnrichmentEnabledRequest, "typeName", "mono.projectdata.v1.SetEnrichmentEnabledRequest");
_define_property(SetEnrichmentEnabledRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "enabled",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetEnrichmentEnabledResponse
 */ export class SetEnrichmentEnabledResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetEnrichmentEnabledResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetEnrichmentEnabledResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetEnrichmentEnabledResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetEnrichmentEnabledResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetEnrichmentEnabledResponse, "runtime", proto3);
_define_property(SetEnrichmentEnabledResponse, "typeName", "mono.projectdata.v1.SetEnrichmentEnabledResponse");
_define_property(SetEnrichmentEnabledResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ReverseEnrichmentRequest
 */ export class ReverseEnrichmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReverseEnrichmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReverseEnrichmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReverseEnrichmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReverseEnrichmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string node_id = 1;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: string application_id = 2;
   */ _define_property(this, "applicationId", ""), /**
   * @generated from field: string rationale = 3;
   */ _define_property(this, "rationale", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReverseEnrichmentRequest, "runtime", proto3);
_define_property(ReverseEnrichmentRequest, "typeName", "mono.projectdata.v1.ReverseEnrichmentRequest");
_define_property(ReverseEnrichmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "application_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReverseEnrichmentResponse
 */ export class ReverseEnrichmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReverseEnrichmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReverseEnrichmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReverseEnrichmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReverseEnrichmentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReverseEnrichmentResponse, "runtime", proto3);
_define_property(ReverseEnrichmentResponse, "typeName", "mono.projectdata.v1.ReverseEnrichmentResponse");
_define_property(ReverseEnrichmentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.ObservationResolutionView
 */ export class ObservationResolutionView extends Message {
    static fromBinary(bytes, options) {
        return new ObservationResolutionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ObservationResolutionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ObservationResolutionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ObservationResolutionView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * keep_distinct | choose_observation | correct_value
   *
   * @generated from field: string outcome = 2;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string chosen_observation_id = 3;
   */ _define_property(this, "chosenObservationId", ""), /**
   * @generated from field: string corrected_value = 4;
   */ _define_property(this, "correctedValue", ""), /**
   * @generated from field: string rationale = 5;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string actor_user_id = 6;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * set on a reversal row
   *
   * @generated from field: string reverses_id = 8;
   */ _define_property(this, "reversesId", ""), /**
   * set on a reversed resolution
   *
   * @generated from field: string reversed_by_id = 9;
   */ _define_property(this, "reversedById", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ObservationResolutionView, "runtime", proto3);
_define_property(ObservationResolutionView, "typeName", "mono.projectdata.v1.ObservationResolutionView");
_define_property(ObservationResolutionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "chosen_observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "corrected_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "reverses_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reversed_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ObservationConflictView
 */ export class ObservationConflictView extends Message {
    static fromBinary(bytes, options) {
        return new ObservationConflictView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ObservationConflictView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ObservationConflictView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ObservationConflictView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string node_id = 1;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: string field = 2;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string scope = 3;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string measure = 4;
   */ _define_property(this, "measure", ""), /**
   * @generated from field: string period_start = 5;
   */ _define_property(this, "periodStart", ""), /**
   * @generated from field: string period_end = 6;
   */ _define_property(this, "periodEnd", ""), /**
   * @generated from field: repeated mono.projectdata.v1.SourceObservationView observations = 7;
   */ _define_property(this, "observations", []), /**
   * full history, oldest first
   *
   * @generated from field: repeated mono.projectdata.v1.ObservationResolutionView resolutions = 8;
   */ _define_property(this, "resolutions", []), /**
   * open | resolved
   *
   * @generated from field: string status = 9;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string preferred_value = 10;
   */ _define_property(this, "preferredValue", ""), /**
   * empty when a correction supplies the value
   *
   * @generated from field: string preferred_observation_id = 11;
   */ _define_property(this, "preferredObservationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ObservationConflictView, "runtime", proto3);
_define_property(ObservationConflictView, "typeName", "mono.projectdata.v1.ObservationConflictView");
_define_property(ObservationConflictView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "measure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "period_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "observations",
            kind: "message",
            T: SourceObservationView,
            repeated: true
        },
        {
            no: 8,
            name: "resolutions",
            kind: "message",
            T: ObservationResolutionView,
            repeated: true
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "preferred_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "preferred_observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListObservationConflictsRequest
 */ export class ListObservationConflictsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListObservationConflictsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListObservationConflictsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListObservationConflictsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListObservationConflictsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional
   *
   * @generated from field: string node_id = 1;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: bool include_resolved = 2;
   */ _define_property(this, "includeResolved", false), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListObservationConflictsRequest, "runtime", proto3);
_define_property(ListObservationConflictsRequest, "typeName", "mono.projectdata.v1.ListObservationConflictsRequest");
_define_property(ListObservationConflictsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_resolved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListObservationConflictsResponse
 */ export class ListObservationConflictsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListObservationConflictsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListObservationConflictsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListObservationConflictsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListObservationConflictsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ObservationConflictView conflicts = 1;
   */ _define_property(this, "conflicts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListObservationConflictsResponse, "runtime", proto3);
_define_property(ListObservationConflictsResponse, "typeName", "mono.projectdata.v1.ListObservationConflictsResponse");
_define_property(ListObservationConflictsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conflicts",
            kind: "message",
            T: ObservationConflictView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveObservationConflictRequest
 */ export class ResolveObservationConflictRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveObservationConflictRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveObservationConflictRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveObservationConflictRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveObservationConflictRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string node_id = 1;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: string field = 2;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string scope = 3;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string measure = 4;
   */ _define_property(this, "measure", ""), /**
   * @generated from field: string period_start = 5;
   */ _define_property(this, "periodStart", ""), /**
   * @generated from field: string period_end = 6;
   */ _define_property(this, "periodEnd", ""), /**
   * @generated from field: string outcome = 7;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string chosen_observation_id = 8;
   */ _define_property(this, "chosenObservationId", ""), /**
   * @generated from field: string corrected_value = 9;
   */ _define_property(this, "correctedValue", ""), /**
   * @generated from field: string rationale = 10;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string user_id = 11;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 12;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveObservationConflictRequest, "runtime", proto3);
_define_property(ResolveObservationConflictRequest, "typeName", "mono.projectdata.v1.ResolveObservationConflictRequest");
_define_property(ResolveObservationConflictRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "measure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "period_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "chosen_observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "corrected_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ResolveObservationConflictResponse
 */ export class ResolveObservationConflictResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveObservationConflictResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveObservationConflictResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveObservationConflictResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveObservationConflictResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ObservationResolutionView resolution = 1;
   */ _define_property(this, "resolution", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveObservationConflictResponse, "runtime", proto3);
_define_property(ResolveObservationConflictResponse, "typeName", "mono.projectdata.v1.ResolveObservationConflictResponse");
_define_property(ResolveObservationConflictResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "resolution",
            kind: "message",
            T: ObservationResolutionView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReverseObservationResolutionRequest
 */ export class ReverseObservationResolutionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReverseObservationResolutionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReverseObservationResolutionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReverseObservationResolutionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReverseObservationResolutionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * the entity the resolution belongs to (authz target)
   *
   * @generated from field: string node_id = 1;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: string resolution_id = 2;
   */ _define_property(this, "resolutionId", ""), /**
   * @generated from field: string rationale = 3;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReverseObservationResolutionRequest, "runtime", proto3);
_define_property(ReverseObservationResolutionRequest, "typeName", "mono.projectdata.v1.ReverseObservationResolutionRequest");
_define_property(ReverseObservationResolutionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "resolution_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReverseObservationResolutionResponse
 */ export class ReverseObservationResolutionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReverseObservationResolutionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReverseObservationResolutionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReverseObservationResolutionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReverseObservationResolutionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.ObservationResolutionView resolution = 1;
   */ _define_property(this, "resolution", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReverseObservationResolutionResponse, "runtime", proto3);
_define_property(ReverseObservationResolutionResponse, "typeName", "mono.projectdata.v1.ReverseObservationResolutionResponse");
_define_property(ReverseObservationResolutionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "resolution",
            kind: "message",
            T: ObservationResolutionView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ObservationExceptionView
 */ export class ObservationExceptionView extends Message {
    static fromBinary(bytes, options) {
        return new ObservationExceptionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ObservationExceptionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ObservationExceptionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ObservationExceptionView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string node_id = 2;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: string field = 3;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string scope = 4;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string measure = 5;
   */ _define_property(this, "measure", ""), /**
   * @generated from field: string period_start = 6;
   */ _define_property(this, "periodStart", ""), /**
   * @generated from field: string period_end = 7;
   */ _define_property(this, "periodEnd", ""), /**
   * @generated from field: string fingerprint = 8;
   */ _define_property(this, "fingerprint", ""), /**
   * @generated from field: string evidence = 9;
   */ _define_property(this, "evidence", ""), /**
   * open | resolved
   *
   * @generated from field: string status = 10;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 seen_count = 11;
   */ _define_property(this, "seenCount", 0), /**
   * @generated from field: google.protobuf.Timestamp first_seen_at = 12;
   */ _define_property(this, "firstSeenAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp last_seen_at = 13;
   */ _define_property(this, "lastSeenAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 14;
   */ _define_property(this, "resolvedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ObservationExceptionView, "runtime", proto3);
_define_property(ObservationExceptionView, "typeName", "mono.projectdata.v1.ObservationExceptionView");
_define_property(ObservationExceptionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "measure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "seen_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "first_seen_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "last_seen_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * OriginAdoptionView never changes once written; accepting a newer origin
 * appends a new row and stamps superseded_by_id on this one.
 *
 * @generated from message mono.projectdata.v1.OriginAdoptionView
 */ export class OriginAdoptionView extends Message {
    static fromBinary(bytes, options) {
        return new OriginAdoptionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OriginAdoptionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OriginAdoptionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OriginAdoptionView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string node_id = 2;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: string field = 3;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string scope = 4;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string measure = 5;
   */ _define_property(this, "measure", ""), /**
   * @generated from field: string period_start = 6;
   */ _define_property(this, "periodStart", ""), /**
   * @generated from field: string period_end = 7;
   */ _define_property(this, "periodEnd", ""), /**
   * @generated from field: string consumer_kind = 8;
   */ _define_property(this, "consumerKind", ""), /**
   * @generated from field: string consumer_id = 9;
   */ _define_property(this, "consumerId", ""), /**
   * @generated from field: string adopted_value = 10;
   */ _define_property(this, "adoptedValue", ""), /**
   * @generated from field: string origin_observation_id = 11;
   */ _define_property(this, "originObservationId", ""), /**
   * @generated from field: string origin_source = 12;
   */ _define_property(this, "originSource", ""), /**
   * @generated from field: string origin_source_record_id = 13;
   */ _define_property(this, "originSourceRecordId", ""), /**
   * @generated from field: string origin_source_record_version = 14;
   */ _define_property(this, "originSourceRecordVersion", ""), /**
   * @generated from field: string origin_fingerprint = 15;
   */ _define_property(this, "originFingerprint", ""), /**
   * @generated from field: google.protobuf.Timestamp adopted_at = 16;
   */ _define_property(this, "adoptedAt", void 0), /**
   * @generated from field: string actor_user_id = 17;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string supersedes_id = 18;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: string superseded_by_id = 19;
   */ _define_property(this, "supersededById", ""), /**
   * Derived on read, never stored.
   *
   * @generated from field: bool newer_origin_available = 20;
   */ _define_property(this, "newerOriginAvailable", false), /**
   * @generated from field: string origin_current_value = 21;
   */ _define_property(this, "originCurrentValue", ""), /**
   * @generated from field: string origin_current_source = 22;
   */ _define_property(this, "originCurrentSource", ""), /**
   * @generated from field: string origin_current_fingerprint = 23;
   */ _define_property(this, "originCurrentFingerprint", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OriginAdoptionView, "runtime", proto3);
_define_property(OriginAdoptionView, "typeName", "mono.projectdata.v1.OriginAdoptionView");
_define_property(OriginAdoptionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "measure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "consumer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "adopted_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "origin_observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "origin_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "origin_source_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "origin_source_record_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "origin_fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "adopted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "newer_origin_available",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "origin_current_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "origin_current_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "origin_current_fingerprint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RefreshSourceObservationsRequest
 */ export class RefreshSourceObservationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new RefreshSourceObservationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshSourceObservationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshSourceObservationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshSourceObservationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.SourceObservationView observations = 1;
   */ _define_property(this, "observations", []), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * Refresh the selected entity from stored provider evidence. Mutually
   * exclusive with observations; the browser never constructs source facts.
   *
   * @generated from field: string node_id = 4;
   */ _define_property(this, "nodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshSourceObservationsRequest, "runtime", proto3);
_define_property(RefreshSourceObservationsRequest, "typeName", "mono.projectdata.v1.RefreshSourceObservationsRequest");
_define_property(RefreshSourceObservationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observations",
            kind: "message",
            T: SourceObservationView,
            repeated: true
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RefreshSourceObservationsResponse
 */ export class RefreshSourceObservationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new RefreshSourceObservationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshSourceObservationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshSourceObservationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshSourceObservationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 observations_inserted = 1;
   */ _define_property(this, "observationsInserted", 0), /**
   * @generated from field: int32 exceptions_opened = 2;
   */ _define_property(this, "exceptionsOpened", 0), /**
   * @generated from field: int32 exceptions_deduped = 3;
   */ _define_property(this, "exceptionsDeduped", 0), /**
   * @generated from field: repeated mono.projectdata.v1.ObservationExceptionView exceptions = 4;
   */ _define_property(this, "exceptions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshSourceObservationsResponse, "runtime", proto3);
_define_property(RefreshSourceObservationsResponse, "typeName", "mono.projectdata.v1.RefreshSourceObservationsResponse");
_define_property(RefreshSourceObservationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observations_inserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "exceptions_opened",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "exceptions_deduped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "exceptions",
            kind: "message",
            T: ObservationExceptionView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListObservationExceptionsRequest
 */ export class ListObservationExceptionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListObservationExceptionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListObservationExceptionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListObservationExceptionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListObservationExceptionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional
   *
   * @generated from field: string node_id = 1;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: bool include_resolved = 2;
   */ _define_property(this, "includeResolved", false), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListObservationExceptionsRequest, "runtime", proto3);
_define_property(ListObservationExceptionsRequest, "typeName", "mono.projectdata.v1.ListObservationExceptionsRequest");
_define_property(ListObservationExceptionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_resolved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListObservationExceptionsResponse
 */ export class ListObservationExceptionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListObservationExceptionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListObservationExceptionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListObservationExceptionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListObservationExceptionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ObservationExceptionView exceptions = 1;
   */ _define_property(this, "exceptions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListObservationExceptionsResponse, "runtime", proto3);
_define_property(ListObservationExceptionsResponse, "typeName", "mono.projectdata.v1.ListObservationExceptionsResponse");
_define_property(ListObservationExceptionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exceptions",
            kind: "message",
            T: ObservationExceptionView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AdoptOriginValueRequest
 */ export class AdoptOriginValueRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdoptOriginValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptOriginValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptOriginValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptOriginValueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string node_id = 1;
   */ _define_property(this, "nodeId", ""), /**
   * @generated from field: string field = 2;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string scope = 3;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string measure = 4;
   */ _define_property(this, "measure", ""), /**
   * @generated from field: string period_start = 5;
   */ _define_property(this, "periodStart", ""), /**
   * @generated from field: string period_end = 6;
   */ _define_property(this, "periodEnd", ""), /**
   * @generated from field: string consumer_kind = 7;
   */ _define_property(this, "consumerKind", ""), /**
   * @generated from field: string consumer_id = 8;
   */ _define_property(this, "consumerId", ""), /**
   * @generated from field: string user_id = 9;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 10;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptOriginValueRequest, "runtime", proto3);
_define_property(AdoptOriginValueRequest, "typeName", "mono.projectdata.v1.AdoptOriginValueRequest");
_define_property(AdoptOriginValueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "measure",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "period_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "consumer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AdoptOriginValueResponse
 */ export class AdoptOriginValueResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdoptOriginValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptOriginValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptOriginValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptOriginValueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OriginAdoptionView adoption = 1;
   */ _define_property(this, "adoption", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptOriginValueResponse, "runtime", proto3);
_define_property(AdoptOriginValueResponse, "typeName", "mono.projectdata.v1.AdoptOriginValueResponse");
_define_property(AdoptOriginValueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption",
            kind: "message",
            T: OriginAdoptionView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListOriginAdoptionsRequest
 */ export class ListOriginAdoptionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOriginAdoptionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOriginAdoptionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOriginAdoptionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOriginAdoptionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional
   *
   * @generated from field: string node_id = 1;
   */ _define_property(this, "nodeId", ""), /**
   * optional
   *
   * @generated from field: string consumer_kind = 2;
   */ _define_property(this, "consumerKind", ""), /**
   * optional
   *
   * @generated from field: string consumer_id = 3;
   */ _define_property(this, "consumerId", ""), /**
   * @generated from field: bool include_superseded = 4;
   */ _define_property(this, "includeSuperseded", false), /**
   * @generated from field: string user_id = 5;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 6;
   */ _define_property(this, "companyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOriginAdoptionsRequest, "runtime", proto3);
_define_property(ListOriginAdoptionsRequest, "typeName", "mono.projectdata.v1.ListOriginAdoptionsRequest");
_define_property(ListOriginAdoptionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "consumer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "include_superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListOriginAdoptionsResponse
 */ export class ListOriginAdoptionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOriginAdoptionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOriginAdoptionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOriginAdoptionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOriginAdoptionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.OriginAdoptionView adoptions = 1;
   */ _define_property(this, "adoptions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOriginAdoptionsResponse, "runtime", proto3);
_define_property(ListOriginAdoptionsResponse, "typeName", "mono.projectdata.v1.ListOriginAdoptionsResponse");
_define_property(ListOriginAdoptionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoptions",
            kind: "message",
            T: OriginAdoptionView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AcceptNewerOriginRequest
 */ export class AcceptNewerOriginRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcceptNewerOriginRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptNewerOriginRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptNewerOriginRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptNewerOriginRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string adoption_id = 1;
   */ _define_property(this, "adoptionId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * the entity the adoption belongs to (authz target)
   *
   * @generated from field: string node_id = 4;
   */ _define_property(this, "nodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptNewerOriginRequest, "runtime", proto3);
_define_property(AcceptNewerOriginRequest, "typeName", "mono.projectdata.v1.AcceptNewerOriginRequest");
_define_property(AcceptNewerOriginRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AcceptNewerOriginResponse
 */ export class AcceptNewerOriginResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcceptNewerOriginResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptNewerOriginResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptNewerOriginResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptNewerOriginResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.OriginAdoptionView adoption = 1;
   */ _define_property(this, "adoption", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptNewerOriginResponse, "runtime", proto3);
_define_property(AcceptNewerOriginResponse, "typeName", "mono.projectdata.v1.AcceptNewerOriginResponse");
_define_property(AcceptNewerOriginResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "adoption",
            kind: "message",
            T: OriginAdoptionView
        }
    ]));
